import { IUsersTableRow } from 'src/components/profileComponents/Common';
import { IComplexUser } from 'src/typings/user';

export const complexUsersTableRows: IUsersTableRow[] = [
  {
    id: 1, fieldName: 'username', headerName: 'Select all users at this page', headerAlign: 'left', align: 'left', width: 3, flex: 3,
  },
  {
    id: 2, fieldName: 'role', headerName: 'Role', headerAlign: 'left', align: 'left', width: 2, flex: 2,
  },
  {
    id: 3, fieldName: 'status', headerName: 'Status', headerAlign: 'center', align: 'center', width: 1, flex: 1,
  },
];

export enum EditComplexUsersAssignType {
  notAssigned = 'notAssigned',
  assigned = 'assigned',
}

export const EditComplexUsersQueryType = {
  [EditComplexUsersAssignType.notAssigned]: 'complexesNotIn',
  [EditComplexUsersAssignType.assigned]: 'complexes',
};

export interface ISelectedUsers {
  [EditComplexUsersAssignType.assigned]: IComplexUser[];
  [EditComplexUsersAssignType.notAssigned]: IComplexUser[];
}
